<div class="order-posted-tags-form lum-modal">
  <div class="lum-modal__header flex justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >Add Sales Order/s to Picklist</span
    >
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        mat-dialog-close
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>

  <mat-dialog-content>
    <div class="">
      <lum-filter-order
        [withoutPicklist]="true"
        (onFilterSelect)="onSelectTags($event)"
      ></lum-filter-order>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      type="button"
      class="lum-button lum-button--tertiary mr-2"
      mat-button
      mat-dialog-close
    >
      Cancel
    </button>
    <button
      [disabled]="!orders.length"
      (click)="onSubmitForm()"
      mat-button
      type="button"
      class="lum-button"
    >
      Add to Picklist
    </button>
  </mat-dialog-actions>
</div>
